module.exports = __webpack_public_path__ + "static/media/047.0a469f06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/047.jpg
// module id = 342
// module chunks = 0